import "./signature-content.scss";
import ReactSignatureCanvas from "react-signature-canvas";
import { base64ToFile } from "@shared/utility/convert-base64-to-file";
import { useRef, useState } from "react";
import { useNotificationContext } from "../notification/notification.context";
import { Button } from "primereact/button";

/* eslint-disable-next-line */
export interface SignatureContentProps {
  setSignature: (file: File | null) => void;
  setPreviewSignature?: (signature: string) => void;
}

export function SignatureContent({
  setSignature,
  setPreviewSignature,
}: SignatureContentProps) {
  const { showError } = useNotificationContext();
  const sigCanvas = useRef<any>();
  const [signaturePreview, setSignaturePreview] = useState<string | null>(null);

  // LOCAL FUNCTION
  const handleSaveSignature = () => {
    if (sigCanvas.current?.isEmpty()) {
      showError("Please provide a signature before saving.");
      return;
    }

    const signatureImg = sigCanvas.current?.getCanvas().toDataURL("image/png");

    if (signatureImg) {
      const signatureFile = base64ToFile(signatureImg, "signature.png");

      if (setSignature) {
        setSignature(signatureFile);
      }

      const previewUrl = URL.createObjectURL(signatureFile);
      setSignaturePreview(previewUrl);

      if (setPreviewSignature) {
        setPreviewSignature(previewUrl);
      }
    }
  };

  const handleClearSignature = () => {
    sigCanvas.current.clear();
    setSignaturePreview(null);

    if (setSignature) {
      setSignature(null);
    }
  };

  return (
    <div id="SignatureContent" className="signature-content">
      <section className="flex flex-col justify-center">
        <label className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-2">Signature</label>
        <div className="flex flex-col md:flex-row gap-6 items-start">
          <div className="signature-wrapper flex flex-col">
            <ReactSignatureCanvas
              ref={sigCanvas}
              penColor="black"
              canvasProps={{
                width: 400,
                height: 200,
                className: "signature-canvas border border-gray-300 rounded-lg bg-white",
              }}
              minWidth={2}
              maxWidth={4}
            />
            <div className="flex gap-2 mt-3">
              <Button label="Clear" outlined severity="secondary" onClick={handleClearSignature} />
              <Button label="Verify Signature" onClick={handleSaveSignature} />
            </div>
          </div>

          {signaturePreview && (
            <div className="flex flex-col items-center justify-center border border-dashed border-green-300 bg-green-50 rounded-lg p-4 h-[200px] w-[200px]">
              <span className="text-xs font-semibold text-green-700 uppercase tracking-wider mb-2">Verified</span>
              <img
                src={signaturePreview}
                alt="Verified Signature"
                className="max-h-[120px] max-w-[160px] object-contain"
              />
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

export default SignatureContent;
